import { Offer } from 'src/common/types/models/Offer'
import { ZERO } from 'src/common/utils/big-utils'
import { displayAmount } from 'src/common/utils/formatters/number'
import React, { MouseEvent, useMemo } from 'react'

import useToggle from 'src/common/hooks/helpers/useToggle'
import './styles.css'

interface OfferPriceProps {
  amountIn: Offer['amountIn']
  amountOut: Offer['amountOut']
  depositAsset: Offer['depositAsset']
  withdrawalAsset: Offer['withdrawalAsset']
}

const OfferPrice: React.FC<OfferPriceProps> = ({
  amountIn,
  amountOut,
  depositAsset,
  withdrawalAsset,
}) => {
  const { isOn: isSwap, toggle } = useToggle()

  const toggleSwap = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    toggle()
  }

  const pricePerUnit = useMemo(() => {
    if (!amountIn || !amountOut || amountOut.eq(ZERO) || amountIn.eq(ZERO))
      return ZERO

    return isSwap ? amountIn.div(amountOut) : amountOut?.div(amountIn)
  }, [amountOut, amountIn, isSwap])

  const [tokenIn, tokenOut] = useMemo(() => {
    return isSwap
      ? [depositAsset, withdrawalAsset]
      : [withdrawalAsset, depositAsset]
  }, [depositAsset, isSwap, withdrawalAsset])

  return (
    <div onClick={toggleSwap} className='comp-offer-price typo-label2'>
      <span className='comp-offer-price-amount'>
        {displayAmount(pricePerUnit)}
      </span>
      &nbsp;
      <span className='comp-offer-price-symbols'>{`${tokenIn.symbol}/${tokenOut.symbol}`}</span>
    </div>
  )
}

export default OfferPrice
